import React, { useState, useEffect, Suspense } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import ReactPlayer from 'react-player'
import { Markup } from 'interweave';
import LoadingBar from 'react-top-loading-bar'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Helmet} from "react-helmet";
import { ReactSession } from 'react-client-session';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import {
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
  PinterestIcon,
  EmailIcon
} from "react-share";

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer';
import ReletedVideos from './ReletedVideos/ReletedVideos';
import SubscribeButton from '../Global/SubscribeButton'
import Comments from '../Comments/Comments';

import styles from '../../App.module.css'
import classes from './Video.module.css'

import noThumb from "../../images/no-thumb.jpg";

function linkify(inputText) {
  var replacedText, replacePattern1, replacePattern2, replacePattern3;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

  //Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

  return replacedText;
}

function percent(first, num_total, precision = 0) {
  if (num_total > 0) {
      let res = Math.round((first / num_total) * 100, precision);
      return res;
  } else if (first > 0) {
      return 100;
  }
  return 0;
}

function Video() {
  const navigate = useNavigate();
  const { id, uid, play_id } = useParams();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [linkSuffix, setLinkSuffix] = useState('');
  const [user, setUser] = useState([]);
  const [video, setVideo] = useState([]);
  const [playlist, setPlaylist] = useState(false);
  const [playlistVideos, setPlaylistVideos] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const [errorStatus, setErrorStatus] = useState(null);
  const [likeType, setLikeType] = useState('');
  const [like, setLike] = useState(0);
  const [dislike, setDislike] = useState(0);
  const [percentage, setPercentage] = useState({
    like: 50,
    dislike: 50
  })
  const [isActive, setIsActive] = useState(false);
  const [copied, setCopied] = useState(false);
  const [tags, setTags] = useState([]);
  // const [relatedVideos, setRelatedVideos] = useState([]);
  const [videoUrl, setVideoUrl] = useState('');
  // const [videoDesc, setVideoDesc] = useState('');
  const [progress, setProgress] = useState(0);
  const [hasPremium, setHasPremium] = useState(false);
  const [imFollowing, setImFollowing] = useState(false);
  ReactSession.setStoreType("localStorage");

  const logged_user = ReactSession.get("logged_user");

  useEffect(() => {
    try{
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }catch(ex){}
  }, []);

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/user.php`, {
      user_id: logged_user,
      action: 'GET_USER_DATA',
      secret_key: process.env.REACT_APP_SECRET_KEY
    }, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).then(res => {
      // console.log(res.data);
      setUser(res.data);
    })

    axios.post(`${process.env.REACT_APP_API_URL}/api/user/has_premium.php`, {
      user_id: logged_user,
    }, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).then(res => {
      // console.log(res.data);
      setHasPremium(res.data.has_premium === 1 ? true : false)
    })

    axios.post(`${process.env.REACT_APP_API_URL}/api/user/check_subscribe.php`, {
      uid: logged_user,
      channel_uid: video.user_id,
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).then(res => {
      // console.log(res.data);
      setImFollowing(res.data.is_subscribed === 1 ? true : false);
    })
  }, [video])

  const getListVideos = (uid) => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/videos.php?page=1&limit=12`, null, {
        params: {
          uid: uid,
          limit: 100
        },
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }).then(res => {
          setPlaylistVideos(res.data)
      }).catch(err => {
        console.log(err);
      })
  }

  const getPlayVideos = (id) => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/playlist.php`, {
      playlist_id: id,
      playlist_type: 1,
      limit: 100,
      action: 'GET_IMAGES'
    }, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    }).then(res => {
      // console.log(res.data);
      setPlaylistVideos(res.data)
    }).catch(err => {
      console.log(err);
    })
  }

  useEffect(() => {
    if(uid !== '' && uid !== undefined) {
      setPlaylist(true);
      getListVideos(uid);
      setLinkSuffix(`list/${uid}`);
    }else if(play_id !== '' && play_id !== undefined) {
      setPlaylist(true);
      getPlayVideos(play_id);
      setLinkSuffix(`playlist/${play_id}`);
    }else {
      setPlaylist(false);
    }
  }, [uid, play_id]);
  
  const addToAlgorithm = () => {
    if(!ReactSession.get('vids')) {
      ReactSession.set('vids', [video.id]);
    }else {
      let vids = ReactSession.get('vids');
      const vid = vids.find(vid => video.id === vid);
      !vid && vids.push(video.id);
      if(vids.length === 10) {
        ReactSession.set('vids', vids.slice(Math.max(vids.length - 10, 0)));
      }else {
        ReactSession.set('vids', vids);
      }
    }
  }

  const getOptions = () => {
    const data = new FormData();
    data.append('option_name[]', 'video-coms');
    data.append('option_name[]', 'Fb_Key');
    data.append('option_name[]', 'monthlycurrency');
    data.append('option_name[]', 'monthlyprice');
    axios.post(`${process.env.REACT_APP_API_URL}/api/get_option.php`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        },
    }).then((res) => {
      // console.log(res.data);
      setOptions(res.data);
    })
  }

  useEffect(() => {
    getOptions();
  }, [])

  const fetchData = async () => {
    await axios.post(`${process.env.REACT_APP_API_URL}/api/video.php`, {
      id: id,
      user_id: logged_user
    }, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(response => {
      // console.log(response.data);

      setVideo(response.data);
      setLike(response.data.liked.replace(/\,/g,'') || 0);
      setDislike(response.data.disliked.replace(/\,/g,'') || 0);

      setProgress(50);
      setLoading(true);

      if(response.data.token !== null && response.data.token !== undefined && response.data.token !== '') {
        const token = response.data.token;
        axios.get(`${process.env.REACT_APP_API_URL}/api/video_tmp.php?type=all&token=${token}`)
        .then(res => {
          const pair = Array.from(res.data.path);
          pair.splice(-4, 0, '-');
          setVideoUrl(`${process.env.REACT_APP_API_URL}/storage/media/${pair.join('')}`);
        })
        .catch(err => {
          console.log(err);
        })
      }else {
        setVideoUrl(response.data.source);
      }

      response.data.tags !== '' && setTags(response.data.tags.split(","));

      setProgress(100);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    })
    .catch(error => {
      console.log(error);
    })
  }

  useEffect(() => {
    if((video.ispremium === '1') && !logged_user) {
      console.log("login please");
      setVideoError(true);
      setErrorStatus(2);
    }else if((video.ispremium === '1') && !hasPremium && (user.group_id > 3)) {
      console.log("Upgrade to premium");
      setVideoError(true);
      setErrorStatus(3);
    }else if((video.private === '1') && !hasPremium && user.group_id > 3) {
      console.log("Upgrade to premium");
      setVideoError(true);
      setErrorStatus(4);
    }else if(((video.privacy === '1') || (video.private === '1')) && !imFollowing) {
      console.log("Please subscribe");
      setVideoError(true);
      setErrorStatus(5);
    }else if((video.nsfw > 0) && (!ReactSession.get('nsfw') || ReactSession.get('nsfw') === 0)) {
      console.log("18+");
      setVideoError(true);
      setErrorStatus(6);
    }
  }, [video]);

  useEffect(() => {
    setVideoError(false);
    setErrorStatus(null);
    fetchData();
    let pbar = document.getElementsByClassName('loading_bar');
    pbar[0].style.setProperty('display', 'none');
  }, [id]);

  const autoPlay = () => {
    let pbar = document.getElementsByClassName('loading_bar');
    pbar[0].style.setProperty('display', 'block');

    let vid = document.getElementsByClassName(`autoPlay`);
    let id = vid[0].id.replace(/\D/g, "");

    setTimeout(() => {
      navigate(`/video/${id}/undefined`)
    }, 3000);
  }

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/playlist.php`, {
            user_id: logged_user,
            action: 'GET_MY_PLAYLISTS'
        }, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            setPlaylists(res.data);
        }).catch(error => {
            console.log(error);
        });
}, [logged_user])

  useEffect(() => {
    if(parseInt(like) < 0) {setLike(0)}
    if(parseInt(like) < 0) {setDislike(0)}

    let likes_percent = 6;
    if(parseInt(like) === 0 && parseInt(dislike) === 0) {
      likes_percent =  percent(1, 1 + 1);
    }else {
      likes_percent =  percent(parseInt(like), parseInt(like) + parseInt(dislike));
    }
    let dislikes_percent = (likes_percent > 0 || parseInt(dislike) > 0)? 100 - likes_percent : 0;

    setPercentage({
      like: likes_percent,
      dislike: dislikes_percent
    });
  }, [like,dislike])

  const updateLikes = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/like.php`,
      {
        vid: id,
        action: 'update_likes'
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }).then(response => {
        // console.log(response.data);
        setLike(response.data.liked);
        setDislike(response.data.disliked);
      }).catch(error => {
        console.log(error);
      })
  }

  const handleLike = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/like.php`,
      {
        uid: logged_user,
        vid: id,
        type: 1
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }).then(response => {
        console.log(response.data);
        // setLike(response.data.liked.replace(/\,/g,''));
        // setDislike(response.data.disliked.replace(/\,/g,''));
        // console.log(response.data);
        response.data.added === '1' ? setLikeType('like') : setLikeType('');
        updateLikes();
      }).catch(error => {
        console.log(error);
      })

    // setLike(parseInt(like) + 1);
  }

  const handleDislike = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/like.php`,
      {
        uid: logged_user,
        vid: id,
        type: 2
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }).then(response => {
        console.log(response.data);
        // setLike(response.data.liked.replace(/\,/g,''));
        // setDislike(response.data.disliked.replace(/\,/g,''));
        response.data.added === '1' ? setLikeType('dislike') : setLikeType('');
        updateLikes();
      }).catch(error => {
        console.log(error);
      })

    // setDislike(parseInt(dislike) + 1);
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  }

  const addToAlbum = (play_id) => {
    const toast_id = toast.loading("Please wait...");
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/playlist.php`, {
            user_id: logged_user,
            play_id: play_id,
            video_id: id,
            action: 'ADD_TO_PLAYLIST'
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            console.log(res.data);
            toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false, closeOnClick: true, rtl: true});
        }).catch(err => {
            console.log(err);
        });
}

const addToWatchLater = () => {
  const toast_id = toast.loading("Please wait...");
  axios.post(`${process.env.REACT_APP_API_URL}/api/user/playlist.php`, {
      user_id: logged_user,
      video_id: id,
      action: 'ADD_TO_WATCH_LATER'
    }, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).then(res => {
      // console.log(res.data);
      toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false, closeOnClick: true, rtl: true});
    }).catch(err => {
      console.log(err);
    });
  }

  const handleNsfw = () => {
    if(!ReactSession.get('nsfw')) {
      ReactSession.set('nsfw', 1)
    }

    setVideoError(false);
    setErrorStatus(null);
  }

  const toggleShare = () => {
    setIsActive(!isActive);
  }

  const copyToClipboard = () => {
    toast.info('Copied!', {
      autoClose: 5000,
      closeOnClick: true,
    });
  }

  const config = "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30";

  return (
    <>
      <Helmet>
        <title>{video.title || 'Video'} - Wesharez</title>
        <meta name="description" content={video.description ? video.description.replace(/<[^>]*>?/gm, '').slice(0, 270) : ''} />
        <meta name="keywords" content={tags.toString() || ''} />
        <meta property="og:image" content={video.thumb}/>
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <ToastContainer />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
            <div className={styles.main_content + ` main-content`}>
                <div className={classes.video_component}>
                  <div className="row">
                    <div className="col-lg-8 col-xs-12 col-sm-12">
                      <div className={classes.video}>
                        {/* <iframe title="video" src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1" width="100%" height="400" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe> */}
                        {/* <video width="320" height="240" controls>
                          <source src="https://wesharez.com/storage/test/2040213165.mp4" type="video/mp4" />
                          <source src="https://wesharez.com/storage/test/2040213165.mp4" type="video/ogg" />
                        </video> */}
                        {
                          !videoError && <ReactPlayer
                            className={classes.player}
                            playing={true}
                            controls={true}
                            playIcon={<i className="fa-solid fa-circle-play"></i>}
                            url={videoUrl}
                            width="100%"
                            height="100%"
                            onReady={() => {
                                console.log("Player ready");
                                addToAlgorithm();
                              }
                            }
                            onEnded = {() => {
                                console.log("Watched Full Video");
                                ReactSession.get('autoplay') && autoPlay();
                              }
                            }
                            onError={e => {
                                console.log("player error");
                                setVideoError(true);
                                setErrorStatus(1);
                              }
                            }
                          />
                        }
                        {
                          errorStatus === 1 && <div className={classes.playerError}>Error loading player: <br /> <span>No playable sources found</span></div>
                        }
                        {
                          errorStatus === 2 && <div className={classes.playerError}>
                            <div className={classes.vpre}>This video is for premium users only!</div> 
                            <div className={classes.vex}>Please login to see this video</div>
                            <div className={classes.loginbtn}><Link className="btn btn-primary" to="/login">Login</Link></div>
                          </div>
                        }
                        {
                          (errorStatus === 3 || errorStatus === 4) && <div className={classes.playerError}>
                            <div className={classes.vpre}>This video is for premium users only!</div> 
                            <div className={classes.vex}>Become a premium user for as low as {options.monthlycurrency} {options.monthlyprice}</div>
                            <div className={classes.upgbtn}><a className="btn btn-primary" href="'.site_url().'payment">Upgrade</a></div>
                          </div>
                        }
                        {
                          errorStatus === 5 && <div className={classes.playerError}>
                            <div className={classes.vpre}>This video is for subscribers only!</div> 
                            <div className={classes.vex}><Link to={`/profile/${video.user_id}/${video.nice_url}`}>Please subscribe to <b>{video.owner}</b> to see this video</Link></div>
                            <div className={classes.upgbtn}><a className="btn btn-primary" href="'.site_url().'payment">Upgrade</a></div>
                          </div>
                        }
                        {
                          errorStatus === 6 && <div className={classes.playerError}>
                            <div className={classes.nsfw_warn}>
                              <span>This video is not safe</span>
                              <Link to={false} onClick={() => handleNsfw()}>I understand and I am over 18</Link>
                              <Link to="/">I am under 18</Link>
                            </div>
                          </div>
                        }
                      </div>
                      <div className={classes.title}>
                        <p>{video.views} views <span>·</span> Release Date: {video.time_ago}</p>
                        <h2><Markup content={video.title} /></h2>
                      </div>
                      {/* advertisement */}
                      <ins className='adsbygoogle p-4 pb-0'
                        style={{ display: 'block' }}
                        data-ad-client='ca-pub-8126596259429304'
                        data-ad-slot='5153011292'
                        data-ad-format='auto'
                      />
                      <div className={classes.author}>
                        <div className={classes.left}>
                          <div className={classes.author_img}>
                            <Link to={`/profile/${video.user_id}/${video.nice_url}`}>
                              <img className="sv-avatar" src={video.avatar} onError={e => {e.target.src = noThumb}} alt={video.owner} />
                            </Link>
                          </div>
                          <div className={classes.name}>
                            <Link to={`/profile/${video.user_id}/${video.nice_url}`}>{video.owner}</Link>
                          </div>
                        </div>
                        <div className={classes.right}>
                          {
                            loading && <SubscribeButton uid={video.user_id} />
                          }
                      </div>
                      </div>
                      <div className={classes.btn_container}>
                        <div className={classes.edit_btn}>
                          {
                            (logged_user && video.user_id === logged_user) && <Link to={`/dashboard/edit-video/${video.id}`}><button class="btn btn-light">Edit media</button></Link>
                          }
                        </div>
                        <div className={classes.interaction_icons}>
                          <div className={classes.likes_bar}>
                            <div className={classes.like_box}>
                              <div className={classes.btn + ' ' + classes.like} onClick={() => handleLike()}>
                                <Link to={false} id="i-like-it" className="pv_tip likes" title="" data-original-title=" Like">
                                  <i className={`fa-solid fa-thumbs-up ${likeType === 'like' ? classes.active : ''}`}></i>
                                  <span>{like}</span>
                                </Link>
                              </div>
                              <div className={classes.btn + ' ' + classes.dislike} onClick={() => handleDislike()}>
                                <Link to={false} id="i-dislike-it" className="pv_tip dislikes " data-toggle="tooltip" data-placement="top" title="" data-original-title=" Dislike">
                                  <i className={`fa-solid fa-thumbs-down ${likeType === 'dislike' ? classes.active : ''}`}></i>
                                  <span>{dislike}</span>
                                </Link>
                              </div>
                            </div>
                            <div className={classes.like_progress}>
                              <div className={classes.likes_success} style={{width: percentage.like+'%'}}></div>
                              <div className={classes.likes_danger} style={{width: percentage.dislike+'%'}}></div>
                            </div>
                          </div>
                          <div className={classes.btn + ' ' + classes.share}>
                            <Link id="social-share" to={false} title="Share or Embed" onClick={() => toggleShare()}>
                              <i className="fa-solid fa-share"></i>
                              <span className="hidden-xs">Share</span>
                            </Link>
                          </div>
                          <div className={classes.btn + ' ' + classes.watch_later}>
                            <Link className="tipS" to={false} title="Watch Later" onClick={() => toggleMenu()}>
                              <i className="fa-regular fa-square-plus"></i>
                              <span className="hidden-xs">Add to</span>
                              <ul className={`dropdown-menu ${classes.playlists} ${isMenuOpen ? classes.active : ''}`} aria-labelledby="dLabel">
                                <li onClick={() => addToWatchLater(id)}><Link to={false}><i className="fa-regular fa-clock"></i>Watch later</Link></li>
                                <div className="dropdown-divider"></div>
                                {
                                    playlists && playlists.map && playlists.map((playlist, index) => {
                                        return (
                                            <li id="PAdd-13" onClick={() => addToAlbum(playlist.id)} key={index}><a href="/"><i className="fa-sharp fa-solid fa-circle-dot"></i>{playlist.title}</a></li>
                                        )
                                    })
                                }
                                {playlists && playlists.map && <div className="dropdown-divider"></div>}
                                <li><Link to="/dashboard/add-playlist"><i className="fa-sharp fa-solid fa-plus"></i>Create playlist</Link></li>
                              </ul>
                            </Link>
                          </div>
                        </div>
                      </div>
                      {/* <div className={`${classes.share_media} ${isActive ? classes.active : ''}`}>
                        <ShareSocial
                          url ={window.location.href}
                          socialTypes={['facebook','twitter','reddit','linkedin', 'whatsapp']}
                        />
                      </div> */}
                      <div className={`${classes.share_media} ${isActive ? classes.active : ''}`}>
                        <div className={classes.social_share}>
                          <p>Share this link via</p>
                          <div className={styles.social_share_buttons}>
                            <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://twitter.com/intent/tweet?url=${window.location.href}&text=${video.title}`, "Popup", config)}>
                              <TwitterIcon size={32} round={true} />
                            </Link>
                            <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${video.title}`, "Popup", config)}>
                              <LinkedinIcon size={32} round={true} />
                            </Link>
                            <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://pinterest.com/pin/create/link/?url=${window.location.href}&title=${video.title}&media=${video.thumb}&description=${video.title}`, "Popup", config)}>
                              <PinterestIcon size={32} round={true} />
                            </Link>
                            <a className={`${styles.social__icon}`} href={`whatsapp://send?text=${window.location.href}`} data-action="share/whatsapp/share">
                              <WhatsappIcon size={32} round={true} />
                            </a>
                            <a className={`${styles.social__icon}`} href={`mailto:?subject=${video.title}&body=${window.location.href}`}>
                              <EmailIcon size={32} round={true} />
                            </a>
                          </div>
                        </div>
                        <p>Or copy link</p>
                        <div className={`${classes.field} input-group`}>
                          <input name="vfile" type="url" id="vfile" className="Share_input_area__tcyqA form-control" placeholder={window.location.href} readOnly={true} />
                          <CopyToClipboard text={`${window.location.href}`}>
                            <button className="btn btn-primary" type="submit" onClick={() => copyToClipboard()}> Copy to clipboard</button>
                          </CopyToClipboard>
                        </div>
                      </div>
                      <div className={classes.video_desc}>
                        {/* <p>{[video.description]}</p>
                        <div dangerouslySetInnerHTML={{__html: `${video.description}`}} /> */}
                        {
                          loading && <Markup content={linkify(video.description)} />
                        }
                      </div>
                      {
                        tags.length !== 0 && <div className={classes.tags}>
                          <h5>Tags:</h5>
                          <ul>
                              {
                                tags.map((tag, index) => {
                                  return (
                                    <li key={index}><Link to={`/search/${tag}`}><Markup content={tag}></Markup></Link></li>
                                  )
                                })
                              }
                          </ul>
                        </div>
                      }
                      {/* <ins className='adsbygoogle p-4'
                          style={{ display: 'block' }}
                          data-ad-client='ca-pub-8126596259429304'
                          data-ad-slot='5153011292'
                          data-ad-format='auto'
                      /> */}
                      {/* Comments Start */}
                      {
                        // options.video_coms === 1 && Comments(video.id)
                        Comments(id, 1)
                      }
                      {/* <ins className='adsbygoogle p-4'
                          style={{ display: 'block' }}
                          data-ad-client='ca-pub-8126596259429304'
                          data-ad-slot='5153011292'
                          data-ad-format='auto'
                      /> */}
                    </div>
                    <div className="col-lg-4 col-xs-12 col-sm-12">
                      {
                        playlist && <div className={classes.video_playlist}>			
                          <ul className={classes.items}>
                            {
                              playlistVideos && playlistVideos.map && playlistVideos.map((video, index) => {
                                let thumb = null;
                                if(video.thumb.includes('storage/media/thumbs/')) {
                                    thumb = `${process.env.REACT_APP_API_URL}/${video.thumb}`;
                                }else {
                                    thumb = video.thumb;
                                }

                                return (
                                  <li id={`video_${video.id}`} className={`${classes.item} ${video.id === id ? classes.playingNow : ''}`}>
                                    <div className={classes.inner}>
                                      <div className={classes.thumb}>
                                        <Link className="clip-link" to={`/video/${video.id}/${video.nice_url}/${linkSuffix}`}>
                                          <span className="clip">
                                            {/* <img src={thumb} alt={video.title} /><span className="vertical-align">*/}
                                            <img src={thumb} onError={e => {e.target.src = noThumb}} alt={video.title} />
                                          </span>
                                          {
                                            (video.duration > 0) && <span className={classes.timer}>{video.video_time}</span>
                                          }				
                                          <span className="overlay"></span>
                                        </Link>
                                      </div>			
                                      <div className={classes.data}>
                                        <span className={classes.title}><Link to={`/video/${video.id}/${video.nice_url}/${linkSuffix}`} rel="bookmark" title={video.title}>{video.title}</Link></span>
                                        <span className={classes.usermeta}>by <Link to={`/profile/${video.user_id}/${video.username}`}> {video.name}</Link></span>
                                      </div>
                                    </div>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        </div>
                      }
                      <ReletedVideos />
                    </div>
                  </div>
                </div>
                <Footer />
            </div>
        </Suspense>
      </div>
    </>
  )
}

export default Video